import React 			from 'react';
import moment 			from 'moment-timezone';
import Slider from 'react-slick';

import BLComponent		from '../../core/_BLComponent.jsx';


import {returnSeriesDates} from '../common/_BDPUtilities.jsx';
import {HoverShowTooltip, HoverHideTooltip}	from '../../common/_Utilities.jsx';
import {bdpDateFormatLong} from './../common/_BDPUtilities.jsx';

function PrevArrow(props) {
	return (
		<button className={`bdp-series-timeline__pagination bdp-series-timeline__pagination--prev ${props.className}`} onClick={props.onClick}>
			<i className="fas fa-chevron-left"/>
		</button>
	);
}

function NextArrow(props) {
	return (
		<button className={`bdp-series-timeline__pagination bdp-series-timeline__pagination--next ${props.className}`} onClick={props.onClick}>
			<i className="fas fa-chevron-right"/>
		</button>
	);
}

export default class TimelineContent extends BLComponent {
	constructor (props) {
		super(props);

		this.state = {
			showTimeline: true
		}

		this.seriesNumber = parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.series = blapp.models.get('listSeries') || [];
		this.seriesContent = this.props.seriesData ? this.props.seriesData : this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
		this.currentDate = blapp.config.server_time;

		this.slickSettings = {
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			initialSlide: this.returnInitialSlide(),
			infinite: false,
			prevArrow: <PrevArrow/>,
			nextArrow: <NextArrow/>,
			responsive: [
				{
					breakpoint: 840,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			,	{
					breakpoint: 568,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}
	}

	returnInitialSlide() {
		let initialSlide = 0;
		let timelineItems = returnSeriesDates(this.seriesContent);

		for(let i = timelineItems.length - 1; i >= 0; i--) {
			if(this.currentDate >= timelineItems[i].dates.start) {
				initialSlide = i;

				break;
			}
		}

		return initialSlide;
	}

	render() {
		const {type} = this.props;
		const isSlider = type == 'past' || type == 'validation' || type == 'post-validation';

		if(isSlider) {
			return this.renderSliderTimeline();
		}else{
			return this.renderStackedTimeline();
		}
	}

	returnPercentPassed(start, end) {
		let percent = 0;

		if(this.currentDate <= start) {
			percent = -1;
		}else if(this.currentDate >= end) {
			percent = 100;
		}else{
			const duration = end - start;
			const progress = this.currentDate - start;

			percent = progress / duration * 100;
		}

		return percent;
	}

	renderSliderTimeline() {
		const {type, classes} = this.props;
		const modifierClass = type == 'past' ? '--series-past' : '';

		let timelineItems = returnSeriesDates(this.seriesContent);
				timelineItems = timelineItems.map((item, idx) => this.returnInlineItem(item, idx));

		return (
			<React.Fragment>
				<div className="bdp-series-timeline__header">
					<h2 className={`bdp-series-timeline__header-title bdp-series-timeline__header-title${modifierClass}`}>What's happening now?<i className="fas fa-info-circle text--small-title js-bottom-right-tooltip l-margin-left--sm" data-tooltip={"All dates and times are in Pacific US Time"} data-tooltip-width={200} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}/></h2>
					<button className="btn btn--link" onClick={() => this.setState({showTimeline: !this.state.showTimeline})}>{this.state.showTimeline ? 'Collapse timeline' : 'Expand timeline'}<i className={`l-margin-left--sm fas fa-fw fa-caret-${this.state.showTimeline ? 'up' : 'down'}`}/></button>
				</div>
				<section className="bdp-series-timeline">
					<div className="bdp-series-timeline__content-container">
						<Slider className="bdp-series-timeline__content" {...this.slickSettings} ref={slider => this.slider = slider}>
							{timelineItems}
						</Slider>
					</div>
				</section>
			</React.Fragment>
		);
	}

	returnGroupedTimeline() {
		const seriesDates = returnSeriesDates(this.seriesContent);
		const groupedTimeline = [];

		seriesDates.forEach(item => {
			const idx = groupedTimeline.findIndex(group => group.year == new Date(item.dates.start).getFullYear());

			if(idx != -1) {
				groupedTimeline[idx].items.push(item);
			}else{
				groupedTimeline.push({year: new Date(item.dates.start).getFullYear(), items: [item]});
			}
		});

		return groupedTimeline;
	}

	formatDate(date, type) {
		if(type == 'short') {
			return moment(date).tz('America/Los_Angeles').format("MMM Do");
		}

		if(type == 'month-year') {
			return moment(date).tz('America/Los_Angeles').format("MMMM YYYY");
		}

		if(type == 'full') {
			return moment(date).tz('America/Los_Angeles').format('MMM Do YYYY');
		}
	}

	returnInlineItem(item, idx) {
		const seriesDates = returnSeriesDates(this.seriesContent);
		const nextItem = seriesDates[idx + 1];

		switch(item.name) {
			case 'paletteAdded':
				return (
					<article key={idx} data-timeline-item={0} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--blue bdp-series-main__timeline-item--validation ${this.currentDate >= nextItem.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-pen-ruler fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">New Palette Released</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'full')}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">Update Studio to access the latest palette containing parts for Series {this.seriesNumber}</div>}
					</article>	
				);

			case 'crowdsourcing':
				return (
					<article key={idx} data-timeline-item={1} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, item.dates.end) > 0 && this.returnPercentPassed(item.dates.start, item.dates.end) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-paper-plane fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, item.dates.end) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Open Submission</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}, {new Date(item.dates.end).getFullYear()}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">Submit your models during the submission window to be considered before the deadline on {blapp.format.formatDateShort(item.dates.end)} at noon Pacific US time.</div>}
					</article>
				);

			case 'validation':
				return (
					<article key={idx} data-timeline-item={2} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, item.dates.end) > 0 && this.returnPercentPassed(item.dates.start, item.dates.end) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-check-to-slot fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, item.dates.end) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Crowd Support</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}, {new Date(item.dates.end).getFullYear()}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">We invite all BrickLink members to vote for their favorite submissions. This crowd vote weighs in alongside the BDP’s internal selection criteria and influences the designs chosen for crowdfunding. </div>}
					</article>
				);

			case 'review':
				return (
					<article key={idx} data-timeline-item={3} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, item.dates.end) > 0 && this.returnPercentPassed(item.dates.start, item.dates.end) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-list-check fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, item.dates.end) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Review</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}, {new Date(item.dates.end).getFullYear()}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">Our team checks every design for building experience, brand fit, and crowd favorites.</div>}
					</article>
				);

			case 'designsAnnounced':
				return (
					<article key={idx} data-timeline-item={4} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, nextItem.dates.start) > 0 && this.returnPercentPassed(item.dates.start, nextItem.dates.start) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= nextItem.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-award-simple fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, nextItem.dates.start) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">5 Designs Announced</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')}, {new Date(item.dates.start).getFullYear()}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">We’ll reveal the five Series {this.seriesNumber} designs. Then we’ll collaborate with fan designers to prepare them for production.</div>}
					</article>
				);

			case 'refining':
				return (
					<article key={idx} data-timeline-item={5} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, item.dates.end) > 0 && this.returnPercentPassed(item.dates.start, item.dates.end) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-screwdriver-wrench fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, item.dates.end) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Refining Finalist Designs</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}, {new Date(item.dates.end).getFullYear()}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">Working with Model Governance and Building Instructions teams, and making any final necessary adjustments before locking the designs for pre-production.</div>}
					</article>
				);

			case 'crowdfunding':
				// this.seriesContent;
				const today = blapp.config.server_time;
				const crowdAnnounced = this.seriesContent.udtCrowdFundingAnnouncement;
				const crowdEnded = this.seriesContent.udtCrowdFundingEnd;

				let crowdEndedWeekLater = new Date(crowdEnded);
						crowdEndedWeekLater.setDate(crowdEndedWeekLater.getDate() + 7);
						crowdEndedWeekLater = crowdEndedWeekLater.getTime();

				return (
					<article key={idx} data-timeline-item={6} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red bdp-series-main__timeline-item--validation ${this.returnPercentPassed(item.dates.start, nextItem.dates.start) > 0 && this.returnPercentPassed(item.dates.start, nextItem.dates.start) < 100 ? 'bdp-series-main__timeline-item--active' : ''} ${this.currentDate >= nextItem.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-circle-dollar-to-slot fa-fw"/>
							</div>
							<div className="bdp-series-main__progress">
								<div className={"bdp-series-main__progress-fill"} style={{width: this.returnPercentPassed(item.dates.start, nextItem.dates.start) + '%'}}></div>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Crowdfunding</div>
							<div className="bdp-series-main__timeline-meta-date">{today > crowdAnnounced && today < crowdEndedWeekLater ? `${bdpDateFormatLong(item.dates.start)} Pacific time` : this.formatDate(item.dates.start, 'month-year')}</div>
						</div>
						{this.state.showTimeline && 
							<div className="bdp-series-main__timeline-details">
								{today > crowdAnnounced && today < crowdEndedWeekLater ? <p className="l-margin-bottom"><strong>Crowdfunding ends on {bdpDateFormatLong(item.dates.end)} Pacific time, or once all sets sell out.</strong></p> : null}
								{this.seriesNumber == 5 ?
									<p>BrickLink members may pre-order their favorite sets, with a limit of 2 of each set per household. All sets that receive over 3,000 pre-orders will be produced. A limited production of each set will be manufactured during a one-time production run.</p>
								:
									<p>BrickLink members may pre-order their favorite sets, with a limit of 2 of each set per household. All sets that receive over 3,000 pre-orders will be produced. Up to 30,000 of each set will be manufactured during a limited, one-time production run.</p>
								}
							</div>
						}
					</article>
				);

			case 'productionStart':
				return (
					<article key={idx} data-timeline-item={7} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red bdp-series-main__timeline-item--validation ${this.currentDate >= item.dates.start ? 'bdp-series-main__timeline-item--active' : ''}`}>
						<div className="bdp-series-main__icon-group">
							<div className="bdp-series-main__timeline-icon">
								<i className="fal fa-cart-flatbed fa-fw"/>
							</div>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Production and Shipping</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'month-year')}</div>
						</div>
						{this.state.showTimeline && <div className="bdp-series-main__timeline-details">We produce the sets in the factory. Orders will be ready to ship approximately 6 months after pre-ordering. Actual dates and shipping times may vary.</div>}
					</article>
				);
		}
	}

	returnStackedItem(item, idx) {
		switch(item.name) {
			case 'paletteAdded':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--blue ${this.currentDate >= item.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-palette fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">New Palette Released</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'full')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">Update Studio to access the latest palette containing parts for Series {this.seriesNumber}</div>
					</div>
				);

			case 'crowdsourcing':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--blue ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-paper-plane fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Open Submission</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}, {new Date(item.dates.end).getFullYear()}</div>
						</div>
						<div className="bdp-series-main__timeline-details">Submit your models during the submission window to be considered before the deadline on {blapp.format.formatDateShort(item.dates.end)} at noon Pacific US time.</div>
					</div>
				);

			case 'validation':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-check-to-slot fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Crowd Support</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">We invite all BrickLink members to vote for their favorite submissions. This crowd vote weighs in alongside the BDP’s internal selection criteria and influences the designs chosen for crowdfunding.</div>
					</div>
				);

			case 'review':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-list-check fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Review</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">Our team checks every design for building experience, brand fit, and crowd favorites.</div>
					</div>
				);

			case 'designsAnnounced':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--green ${this.currentDate >= item.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-award-simple fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">5 Designs Announced</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">We’ll reveal the five Series {this.seriesNumber} designs. Then we’ll collaborate with fan designers to prepare them for production.</div>
					</div>
				);

			case 'refining':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-screwdriver-wrench fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Refining Finalist Designs</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'short')} — {this.formatDate(item.dates.end, 'short')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">Working with Model Governance and Building Instructions teams, and making any final necessary adjustments before locking the designs for pre-production.</div>
					</div>
				);

			case 'crowdfunding':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red ${this.currentDate >= item.dates.end ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-circle-dollar-to-slot fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Crowdfunding</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'month-year')}</div>
						</div>
						{this.seriesNumber == 5 ?
							<p>BrickLink members may pre-order their favorite sets, with a limit of 2 of each set per household. All sets that receive over 3,000 pre-orders will be produced. A limited production of each set will be manufactured during a one-time production run.</p>
						:
							<p>BrickLink members may pre-order their favorite sets, with a limit of 2 of each set per household. All sets that receive over 3,000 pre-orders will be produced. Up to 30,000 of each set will be manufactured during a limited, one-time production run.</p>
						}
					</div>
				);

			case 'productionStart':
				return (
					<div key={idx} className={`bdp-series-main__timeline-item bdp-series-main__timeline-item--red ${this.currentDate >= item.dates.start ? 'bdp-series-main__timeline-item--past' : ''}`}>
						<div className="bdp-series-main__timeline-icon">
							<i className="fal fa-cart-flatbed fa-fw"/>
						</div>
						<div className={`bdp-series-main__timeline-meta`}>
							<div className="bdp-series-main__timeline-meta-title">Production and Shipping</div>
							<div className="bdp-series-main__timeline-meta-date">{this.formatDate(item.dates.start, 'month-year')}</div>
						</div>
						<div className="bdp-series-main__timeline-details">We produce the sets in the factory. Orders will be ready to ship approximately 6 months after pre-ordering. Actual dates and shipping times may vary.</div>
					</div>
				);
		}
	}

	renderStackedTimeline() {
		const groupedTimeline = this.returnGroupedTimeline();

		const timelineContent = groupedTimeline.map((group, idx) => {
			const subItems = group.items.map((item, idx) => {
				return this.returnStackedItem(item, idx);
			});

			return (
				<div key={idx} className="bdp-series-main__timeline-group">
					<div className="bdp-series-main__timeline-label">{group.year}</div>
					{subItems}
				</div>
			);
		});

		return (
			<section className={"bdp-series-main__timeline bdp-series-upcoming__timeline"}>
				<h2 className="bdp-series-main__timeline-title">How Series {this.seriesNumber} will work<i className="fas fa-info-circle text--small-title js-bottom-right-tooltip l-margin-left--sm" data-tooltip={"All dates and times are in Pacific US Time"} data-tooltip-width={200} onMouseOver={(e) => HoverShowTooltip(e)} onMouseOut={(e) => HoverHideTooltip(e)}/></h2>
				{timelineContent}
			</section>
		);
	}
}